export function clearPreviousEdit() {
    localStorage.removeItem('brief:current_edit');
    localStorage.removeItem('brief:current_edit_key');

    // Обновляем текущий URL
    let currentUrl = window.location.href;
    let url = new URL(currentUrl);
    url.searchParams.delete('edit');
    window.history.pushState({}, '', url);
}

export function getCurrentEdit() {
    return localStorage.getItem('brief:current_edit');
}

export function updateCurrentEdit() {
    const id = getCurrentEdit();

    if (id) {
        localStorage.setItem('brief:current_edit', id);
    }
}

export function startNewEdit(id, key='') {
    clearPreviousEdit();
    if (id) {
        localStorage.setItem('brief:current_edit', id);
        localStorage.setItem('brief:current_edit_key', key);
        
        // Обновляем текущий URL
        let currentUrl = window.location.href;
        let url = new URL(currentUrl);
        url.searchParams.set('edit', id);
        window.history.pushState({}, '', url);
    }
}